export const FACEBOOK = 'Facebook';
export const GOOGLE = 'Google';
// // export const BASE_URL = 'http://3.108.220.170/api/v1'
// // export const STATIC_URL = 'http://3.108.220.170/'
// export const BASE_URL = 'http://localhost:3030/v1'
// export const STATIC_URL = 'http://localhost:3030/'
// // export const BASE_URL = 'http://insider.protutor.in/api/v1'
// // export const STATIC_URL = 'http://insider.protutor.in/api/'
export const TOAST_CONFIG = {
    position: "bottom-right",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    }

export const TUITION_STATUS =
[
    {status:0,statusName:'Select Status',disabled:true},
    {status:1,statusName:'Ongoing',disabled:false},
    {status:2,statusName:'Requesting Payment Link',disabled:false},
    {status:3,statusName:'Created Payment Link',disabled:false},
    {status:4,statusName:'Payment Link Sent',disabled:false},
    {status:5,statusName:'Paid',disabled:false},
    {status:10,statusName:'Dispute',disabled:false},
]

export const TUTOR_REG_REASON =
[
    {status:0,statusName:'Already Registered'},
    {status:1,statusName:'Not Interested'},
    {status:2,statusName:'Other'}
]

export const TUTOR_REG_CALL_STATUS =
[
    {status:0,statusName:'Not Attended'},
    {status:1,statusName:'Call Later'},
    {status:2,statusName:'Not Connected'},
    {status:3,statusName:'Busy'},
    {status:4,statusName:'Connected'}
]